import fileDownload from "js-file-download";
import config from "../../../../config/config";
import ApiClient from "../../../ApiClient/ApiClient";
import { IPositionFormConfiguration } from "../elements/types";
import { AxiosResponse } from "axios";
import { InstanceInfo, SpecialInstancesResponse } from "./types";

const elementsApi = new ApiClient("/Instances", config.api.baseUrl);

/**
 * Export positions, file is downloaded
 */
export const exportInstances = (
    projectID: number
): Promise<void> => {

    return elementsApi
        .get(`/export/${projectID}`, {
            responseType: "blob"
        })
        .then((response) => {
            // Promise.resolve(response.data)
            fileDownload(response.data, "instances.xlsx");
            return;
        });
};


/**
 * Get position form configuration - returns form configuration.
 */
export const getSpecialInstances = (
    projectID: string,
): Promise<SpecialInstancesResponse> => {
    return elementsApi
        .get(`/special/${projectID}`)
        .then((response: AxiosResponse<SpecialInstancesResponse>) => {
            return Promise.resolve(response.data);
        });
};


/**
 * Get instance information.
 */
export const getInstanceInformation = (
    projectID: number,
    instanceExternalIDs: string[],
): Promise<InstanceInfo[]> => {
    return elementsApi
        .post(`/info/${projectID}`, instanceExternalIDs)
        .then((response: AxiosResponse<InstanceInfo[]>) => {
            return Promise.resolve(response.data);
        });
};